import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';

import { HashRouter, Route, Routes } from 'react-router-dom';
import ErrorPage from './error-page';
import Dasboard from './components/dasboard';
import Login from './components/userComponents/login.component';
import Register from './components/userComponents/register.component';
import Profile from './components/userComponents/profile.component';
import BoardUser from './components/userComponents/board-user.component';
import BoardModerator from './components/userComponents/board-moderator.component';
import BoardAdmin from './components/userComponents/board-admin.component';
import InputAset from './components/Input';
import Nav from './components/Nav';
import PrintDataAset from './components/printDataAset';
import PrintDataQrcode from './components/printDataQrcode';
import Rekapitulasi from './components/rekapitulasi';
import RincianAset from './components/document/rincianAset';
import RKA from './components/rka';
import VirtualAKun from './components/virtualAkun';
import PendataanAset from './components/inventaris';
import UsulanPembiayaan from './components/usulanPembiayaan';
import EditAset from './components/editAset';
import RincianVA from './components/document/rincianVA';
import GenerateVA from './components/document/generateVA';



ReactDOM.createRoot(document.getElementById('root')).render(

  <HashRouter>
      <Routes>
        <Route path='/' element={<Nav />} errorElement={<ErrorPage />}>
          <Route index element={<Dasboard />} />
          <Route path='input-aset' element={<InputAset />} />
          
          <Route path='rka' element={<RKA />} />
          <Route path='virtual-akun' element={<VirtualAKun />} />
          <Route path='usulan-pembiayaan' element={<UsulanPembiayaan />} />
          <Route path='inventaris' element={<PendataanAset />} />

          <Route path='inventaris' >
            <Route path='print/data/qrcode' element={<PrintDataQrcode />} />
            <Route path='print/data/aset' element={<PrintDataAset />} />
            <Route path='rekapitulasi' element={<Rekapitulasi />} />
          </Route>
          <Route path='edit'>
            <Route path='aset/:id' element={<EditAset />}/>
          </Route>
        </Route>
        <Route path='/login' element={<Login />} />
        <Route path='/register' element={<Register />} />
        <Route path='/profile' element={<Profile />} />
        <Route path='/user' element={<BoardUser />} />
        <Route path='/mod' element={<BoardModerator />} />
        <Route path='/admin' element={<BoardAdmin />} />
        <Route path='/rincian/aset/:id' element={<RincianAset />} />
        <Route path='/rincianVA/:customerNo/:virtualAccountNo/:nama/:nim/:prodi/:fakultas/:billCode/:billName/:billAmountValue/:billDescription/:paidAmount/:trxDateTime/:referenceNo/:paymentFlagReason' element={<RincianVA />} />
        <Route path='/generateVA/:nama/:nim/:prodi/:fakultas/:email/:tlp/:billCode/:billName/:billAmountValue/:billDescription/:expiredDate/:tahunAkademik/:secret' element={<GenerateVA />} />
      </Routes>
    </HashRouter>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
 